import { ReactElement } from "react";
import { MetricsDashboardGraphType } from "../../../__generated__/api";
import PieChart, { PieChartProperties } from "./PieChart";
import BarGraph, { BarGraphProperties } from "./BarChart";
import LineChart, { LineChartProperties } from "./LineChart";

import CountChart, { ChartProperties } from "./Count";
import Table, { TableProperties } from "./Table";
import TimeSeries, { TimeSeriesProperties } from "./TimeSeries";

import { GraphProps, GraphSettingsProperties } from "./base";

const COMPONENT_TO_TYPE: Record<string, (settings: GraphProps) => ReactElement> = {
    [MetricsDashboardGraphType.PieChart]: PieChart,
    [MetricsDashboardGraphType.BarGraph]: BarGraph,
    [MetricsDashboardGraphType.LineGraph]: LineChart,
    [MetricsDashboardGraphType.Count]: CountChart,
    [MetricsDashboardGraphType.Table]: Table,
    [MetricsDashboardGraphType.TimeSeries]: TimeSeries,
};
export default COMPONENT_TO_TYPE;

export const COMPONENT_TO_SETTINGS: Record<string, (settings: GraphSettingsProperties) => ReactElement> = {
    [MetricsDashboardGraphType.PieChart]: PieChartProperties,
    [MetricsDashboardGraphType.BarGraph]: BarGraphProperties,
    [MetricsDashboardGraphType.LineGraph]: LineChartProperties,
    [MetricsDashboardGraphType.Count]: ChartProperties,
    [MetricsDashboardGraphType.Table]: TableProperties,
    [MetricsDashboardGraphType.TimeSeries]: TimeSeriesProperties,
};
